import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import DimensionBars from "@/components/feature/DimensionBars";
import { compareItems } from "@/mocks/compareData";

export default function RankingSection() {
  const focus = compareItems[0];

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="DUEL OF THE WEEK"
          title="本周咖位对决"
          description="挑一组本周讨论度最高的同框，把四个维度完整摊开，看清差距究竟落在哪里。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-secondary-950">
                <i className="ri-award-line text-sm" />
                本周焦点
              </span>
              <span className="text-xs text-foreground-500">{focus.category}</span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              {focus.title}
            </h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">{focus.summary}</p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="text-xs font-medium tracking-wide text-primary-600">观察结论</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{focus.verdict}</p>
            </div>

            <div className="mt-6">
              <Link
                to={`/compare/${focus.id}`}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整对比
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </Link>
            </div>
          </div>

          <div className="flex items-center rounded-lg border border-background-200 bg-background-50 p-6">
            <DimensionBars
              dimensions={focus.dimensions}
              leftName={focus.leftName}
              rightName={focus.rightName}
            />
          </div>
        </div>
      </Container>
    </section>
  );
}